<template>
  <survey-management template-id="OpinionSurvey" />
</template>
<script>
import SurveyManagement from "./SurveyManagement";

export default {
  name: "OpinionSurveyManagment",
  components: { SurveyManagement },
};
</script>

<style lang="sass" scoped>

/* components/OpinionSurveyManagment */
@import "../assets/css/variables.scss"

h2
  margin-bottom: 30px

h3
  font-size: 1.5rem
  margin-right: 15px
  color: $accent-color
  margin-top: 13px


.input-group > .form-control
  height: 54px
  background-color: $accent-color
  border-radius: 20px
  color: #fff
  font-size: 20px
  margin-bottom: 25px
  text-align: center

.btn-outline-secondary
  border-radius: 10px
  margin-left: 15px
  font-size: 1.2rem
  margin-top: 6px
  height: 40px
.btn-secondary
  border-radius: 10px
  margin-top: 2rem

.statistics
  text-align: center
  font-weight: bold
  background-color: #f1f2f2
  padding-top: 10px
  span
    color: $accent-color
    &.filtered
      color: $primary-color
.bulk-small
  font-size: 0.9em

.bulk
  min-height: 35px
  background-color: $accent-color
  text-align: center
  font-family: $font-title
  color: #fff
  font-size: 1.2rem
  .title
    margin-top: 4px
  .btn-link
    color: #fff
    font-size: 1.2rem
    padding: 0px
.select-all-bulk
  position: relative
  input
    position: absolute
    top: 12px
    z-index: 1000
    left: 22px
.selectBar
  background-color: $accent-color
  color: #FFFFFF
  .select
    font-size: 13px
    font-weight: 100
    padding: 5px
.hiddenToggle
  position: relative !important
  background: #000000
  border: none
  height: 1px
  width: 1px

div#dropdown-dropup
  height: 1px
  width: 1px
  padding: 0
  margin: 0 !important
  position: relative

@media (max-width: 768px)
  .btn-secondary
    margin-top: 0
    margin-bottom: 1rem
</style>
